// ─────────────────────────────────────────────────────────────────────────────
//  CHANGELOG TOM — „Ce e nou"
//
//  Cum adaugi o versiune nouă (la fiecare actualizare a platformei):
//   1. Pune o intrare NOUĂ în CAPUL listei CHANGELOG (cele mai noi versiuni SUS).
//   2. Actualizează APP_VERSION cu noul număr.
//   3. Scrie schimbările PE ÎNȚELESUL UTILIZATORILOR (ce văd/folosesc ei), nu termeni tehnici.
//   Format dată: "YYYY-MM-DD" (se afișează automat în română, ex. „17 iunie 2026").
// ─────────────────────────────────────────────────────────────────────────────

export const APP_VERSION = "2.1.1";

export const CHANGELOG = [
    {
        version: "2.1.1",
        date: "2026-08-18",
        title: "Reparare taskuri întârziate pe Dashboard",
        changes: [
            "Am reparat cardul „Întârziate” de pe Dashboard: la unii dintre voi arăta un număr, dar la click lista apărea goală. Acum cifra de pe card și lista de dedesubt arată exact aceleași taskuri.",
            "Dacă ai multe taskuri, Dashboard-ul îți arăta doar o parte din ele — cele vechi, deja finalizate, ocupau locul celor la zi. Acum îți vezi toate taskurile actuale.",
            "Taskurile mutate pe „Stand By” sau ajunse în „Finalizat” nu mai sunt numărate ca întârziate.",
        ],
    },
    {
        version: "2.1.0",
        date: "2026-06-17",
        title: "Poză de profil & Master backup",
        changes: [
            "Îți poți pune o poză de profil personalizată: Setări → Profil → „Încarcă poză”. Apare peste tot în aplicație (board-uri, echipe, chat, comentarii etc.). Poți reveni oricând la inițială + culoare.",
            "Pentru administratori: opțiune nouă „Master backup” (Admin → Backup) care descarcă o singură arhivă cu TOATĂ baza de date și TOATE fișierele (atașamente + poze de profil) — pentru recuperare totală.",
        ],
    },
    {
        version: "2.0.0",
        date: "2026-06-17",
        title: "Design nou & dashboard reorganizat",
        changes: [
            "Design nou, luminos, în toată aplicația — am renunțat la tema întunecată.",
            "Pe pagina unui workspace poți alege ce echipă să vezi, iar alegerea ta este reținută data viitoare.",
            "Poți rearanja board-urile trăgându-le de mâner și poți fixa (📌) board-urile preferate sus — sunt personale și se sincronizează pe toate dispozitivele tale.",
            "Fiecare board afișează primele taskuri, cu derulare pentru rest, ca totul să fie mai aerisit.",
            "Am adăugat secțiunea „Ce e nou” și numărul versiunii, jos, lângă numele tău.",
        ],
    },
];

const RO_MONTHS = [
    "ianuarie", "februarie", "martie", "aprilie", "mai", "iunie",
    "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie",
];

// Formatează "YYYY-MM-DD" → „17 iunie 2026" (fără probleme de fus orar).
export function formatRoDate(iso) {
    if (!iso) return "";
    const parts = String(iso).split("-").map(Number);
    const [y, m, d] = parts;
    if (!y || !m || !d || m < 1 || m > 12) return iso;
    return `${d} ${RO_MONTHS[m - 1]} ${y}`;
}

// Data ultimei actualizări (versiunea din capul listei).
export const LAST_UPDATED = CHANGELOG[0] ? CHANGELOG[0].date : "";
